import PaymentChart from "../../../components/PaymentChart";
import PaymentList from "../../../components/PaymentList";

function PaymentsPage() {
  return (
    <section className="flex flex-col align-center justify-center gap-10">
      <PaymentChart />
      <PaymentList />
    </section>
  );
}
export default PaymentsPage;
